import { useMutation, useQuery } from 'react-apollo';

import { MeQuery } from '../../../../../../../../../graphql/queries/account';
import getCardCategoriesQuery from '../../../../../../../../cards/graphql/queries/getCardCategories';
import useAuthenticated from '../../../../../../../../../hooks/useAuthenticated';
import getUserAccountCardsQuery from '../../../../../../../views/AccountCards/graphql/queries/getUserAccountCards';
import useOpenAlert from '../../../../../../../../../hooks/useOpenAlert';
import { accountCardsDelete as accountCardsDeleteMutation } from '../../../../../../../../../services/cards/graphql/mutations/accountCard';
import { getErrorString } from '../../../../../../../../../util/normalize-errors';
import { AlbumFolderForOwnershipCheck } from '../../../../../../../../../graphql/queries/album-folder';
import { isAlbumFolderOwner } from '../../../../../../../../../util/account';

const useSaveTheDateSetup = ({ albumFolderId }) => {
  const openAlert = useOpenAlert();
  const authenticated = useAuthenticated();
  const { data: { me: account } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  const { data: { cardCategories } = {} } = useQuery(getCardCategoriesQuery, {
    variables: {
      name: 'Save the Date',
      limit: 1,
    },
  });
  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderForOwnershipCheck,
    {
      variables: {
        id: albumFolderId,
      },
      skip: !albumFolderId,
    },
  );

  const {
    data: { me: meWithSaveTheDates } = {},
    loading: loadingSaveTheDates,
    refetch: refetchMeWithSaveTheDates,
  } = useQuery(getUserAccountCardsQuery, {
    variables: {
      accountCardAlbumFolderId: albumFolderId,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const [accountCardsDelete] = useMutation(accountCardsDeleteMutation);

  const saveTheDateAccountCard =
    meWithSaveTheDates?.account_cards?.records?.[0];

  const onAccountCardDelete = async accountCard => {
    if (!accountCard) {
      return;
    }

    await accountCardsDelete({
      variables: {
        input: {
          account_card_ids: [accountCard.id],
        },
      },
    });
  };

  const onCheckoutSuccess = async () => {
    try {
      await refetchMeWithSaveTheDates?.();
    } catch (e) {
      openAlert(getErrorString(e));
    }
  };

  return {
    account,
    loadingSaveTheDates,
    saveTheDateAccountCard,
    saveTheDateCategory: cardCategories?.records?.[0],
    onAccountCardDelete,
    onCheckoutSuccess,
    isOwner: isAlbumFolderOwner(account, albumFolder),
  };
};

export default useSaveTheDateSetup;
